import { ActionSet } from '@futrli/shared-services';

import { RESET_ERROR_SUFFIX } from '../constants';

export const resetError = (actionSet: ActionSet) => {
  return {
    type: `${actionSet.REJECTED}${RESET_ERROR_SUFFIX}`
  };
};
